import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Header } from '@stockcare-models/Header';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  header = new BehaviorSubject<Header>(new Header());
  theatreTimer = new BehaviorSubject<number>(undefined);
  recoveryTimer = new BehaviorSubject<number>(undefined);
  isOnline: boolean = false;
  back = new Subject<boolean>();
  navUrl: string = '';
  constructor() {}

  getIsOnline(): boolean {
    return this.isOnline;
  }

  updateHeader(header: Header) {
    setTimeout(() => {
      this.header.next(header);
    });
  }

  backArrowClicked(value: boolean) {
    this.back.next(value);
  }
}
